<template>
  <div class="content">
    <div class="content_title">
      Список пользовательских соглашений
    </div>
    <div class="content_row" v-for="(agreement, key) in agreements" :key="key">
      <button @click="detailAgreement(agreement.ID)">
        Подробности
      </button>
      <div>{{ getDocumentData(agreement.CONTRACT) }}</div>
      <div>{{ agreement.EDS ? "Подписан" : "Не подписан" }}</div>
    </div>
    <div class="form-row-line">
      <div class="form-field">
        <button @click="tokenToClipboard">
          <span>Копировать токен для 1С</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "GetAgreements",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      url: config.backend_url,
      detailUrl: "",
      userToken: false,
      agreements: [],
      documents: []
    };
  },
  computed: {},
  watch: {
    updateList: state => {
      if (state) this.getAgreements();
    }
  },
  methods: {
    detailAgreement: function(id) {
      this.$router.push({ name: "Agreement", params: { id: id } });
    },
    getDocumentData: function(id) {
      let data = this.documents[id];
      return data ? data.NAME : "";
    },
    getAgreements: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "agreements/get-user-agreements/",
          data: {},
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            this.agreements = data;
            if (this.updateLists) {
              this.$emit("agreement-list-update");
            }
          }
        });
    },
    getUserToken: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "users/get-user-token/",
          data: {},
          method: "POST"
        })
        .then(response => {
          const data = response.data;
          if (!data.error) this.userToken = data;
        });
    },
    getDocuments: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "documents/get/",
          data: {},
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) this.documents = data;
        });
    },
    tokenToClipboard: function(e) {
      const type = "text/plain";
      const blob = new Blob([this.userToken], { type });
      // eslint-disable-next-line no-undef
      const data = [new ClipboardItem({ [type]: blob })];

      navigator.clipboard.write(data).then(
        () => (e.target.innerHTML = "Токен скопирован"),
        () => (e.target.innerHTML = "Ошибка копирования")
      );
    }
  },
  created() {
    this.getAgreements();
    this.getUserToken();
    this.getDocuments();
    this.detailUrl = this.$route.fullPath;
  }
};
</script>
